export default __webpack_public_path__ + "static/media/Xinru_Li.ce7f9e06.pdf";